import { Box, Link, Typography } from 'components/AORedesign';
import { Feature } from 'components/Feature';
import featureFlags from 'constants/featureFlags';
import {
  CUSTOMER_SERVICES_OVERVIEW_LINK,
  CUSTOMER_SERVICES_PHONE_QUICK_REFERENCE_LINK,
  ELECTRONIC_COMMISSION_AGENCY_SWEEP_LINK,
  MAILING_AND_CONTACT_INFORMATION_LINK,
  QUALTRICS_SURVEY_LINK,
} from 'constants/static';
import AccountAdminContext from 'contexts/accountAdmin.context';
import React, { useContext } from 'react';
import AccountAdminSkeleton from './AccountAdminSkeleton';

const ReferenceMaterial = () => {
  const { accountAdminHasData } = useContext(AccountAdminContext);

  return !accountAdminHasData ? (
    <AccountAdminSkeleton />
  ) : (
    <Box mb={4}>
      <Box mt={1} mb={4}>
        <Typography variant="h6">Reference Material</Typography>
      </Box>
      <Box mt={2} mb={4}>
        <Box mb={2}>
          <Typography variant="button" display="block" gutterBottom>
            AGENT FORMS AND REQUESTS
          </Typography>
        </Box>
        <Feature allowed={featureFlags.ACCESS_AGENCY_COMPENSATION_SCHEDULES}>
          <Box mt={1}>
            <Link href="https://brandfolder.com/s/h82tfgwftcjzq6gbrzhznmjw" endIcon="openInNew">
              Agency Compensation Schedules
            </Link>
          </Box>
        </Feature>
        <Box mt={1}>
          <Link href={ELECTRONIC_COMMISSION_AGENCY_SWEEP_LINK} endIcon="openInNew">
            Electronic Commission & Agency Sweep Authorization Form
          </Link>
        </Box>
        <Box mt={1}>
          <Link href={QUALTRICS_SURVEY_LINK} endIcon="openInNew">
            Download/Retransmit Requests
          </Link>
        </Box>
        <Box mt={1}>
          <Link href={'https://brandfolder.com/s/38xk5873nvp8ntcwhw256hxv'} endIcon="openInNew">
            Change of Agency Information Request
          </Link>
        </Box>
      </Box>
      <Box mt={2} mb={2}>
        <Typography variant="button" display="block" gutterBottom>
          CONTACT INFORMATION
        </Typography>
      </Box>
      <Box mt={1}>
        <Link href={CUSTOMER_SERVICES_OVERVIEW_LINK} endIcon="openInNew">
          Customer Services Overview
        </Link>
      </Box>
      <Box mt={1}>
        <Link href={CUSTOMER_SERVICES_PHONE_QUICK_REFERENCE_LINK} endIcon="openInNew">
          Customer Services Phone Line Quick Reference
        </Link>
      </Box>
      <Box mt={1}>
        <Link href={MAILING_AND_CONTACT_INFORMATION_LINK} endIcon="openInNew">
          Mailing & Contact Information
        </Link>
      </Box>
    </Box>
  );
};

export default ReferenceMaterial;
